import ProductShowcase from "../components/ProductShowcase";
import GrainCarousel from "../components/GrainCarousel";
import HomeIntro from "../components/HomeIntro";
import OrganicJourneyBanner from "../components/OrganicJourneyBanner";

export default function Home() {
    return (
        <>
            <section className="hero hero-image-layout fadeInUp">
                <img
                    src="/images/hero.jpeg"
                    alt="Gulmohar Pulses"
                    className="hero-bg"
                    loading="eager"
                />
            </section>

            <HomeIntro />
            <ProductShowcase />
            <GrainCarousel />
            <OrganicJourneyBanner />
        </>
    );
}

